
export const AccountsDashboardPermissions = {
    AccountsDashboard: {
    permissionsId:'94872690-e218-4f9a-a898-08da6e2b177d',
    permissionsName:'Accounts Dashboard',
    componentsId:null,
    components:null
  }
  } ;
  